import { IConsoleArticle } from "@/apps/merchant3/types/in-console/InConsoleArticle";

export const getTrainingArticles = (
  country: string,
  currentPage: string
): Array<IConsoleArticle> => {
  const context = require.context(
    "./in-console-training-articles/",
    true,
    /\.json$/
  );

  const lastSegment = currentPage
    .split("/")
    .filter((p) => p !== "")
    .pop();
  const regex = /^\d+$/;

  if (lastSegment && regex.test(lastSegment)) {
    currentPage = currentPage.replace(/\/[^/]+$/, "/");
  }

  const expectedBasePath = `${country}${currentPage}`;

  return context
    .keys()
    .filter((key) => {
      const path = key.substring(2, key.lastIndexOf("/") + 1);
      return path.startsWith(expectedBasePath);
    })
    .map((key) => context(key));
};
